module.exports = __webpack_public_path__ + "media/packs/images/@tehnobank/logo-12b9ab8f6bac640d4f7f704b0fadf2d1.png";